import { useContext} from "react";
import { useQuery } from "react-query";
import { RobotEnvironmentContext } from "../../contexts/general/RobotEnvironmentContext";
import { PensionContext, PensionParameters } from "../../contexts/pension-robot/PensionContext";
import { buildEndpoint } from "../endpoints";
import { apifetch } from "../robotapi";

export interface PensionDialogueDataResponse {
    id?: string,
    answers?: {
        generalSituation?: {
            age?: number,
            agePartner?: number,
            retirementAge?: number,
            retirementAgePartner?: number,
            workingStatus?: string,
            workingStatusPartner?: string,
            netMonthlyIncome?: number,
            netMonthlyIncomePartner?: number,
            partnerPresent?: boolean,
            yearsAbroad?: number,
            yearsAbroadPartner?: number
        },
        monthlyNetIncomeNeeded?: number,
        monthlyNetIncomeKnownAlready?: boolean,
        house?: {
            typeOfHouse?: string,
            houseValue?: number,
            buyOrRentalHouse?: string,
            mortgageDebtPresent?: boolean,
            mortgageAmount?: number,
            rentalAmount?: number
        },
        cars?: [{
            typeOfCar?: string,
            kilometers?: number,
            statusOfCar?: string,
            valueOfCar?: number
        }],
        costsOverview?: {
            house?: number,
            energy?: number,
            transportation?: number,
            insurance?: number, // TODO: Still under discussion of taken into account. Pension API doesn't return it.
            otherFixedCosts?: number,
            unexpectedAndNecessary?: number,
            leisure?: number,
            household?: number,
            other?: 0
        },
        pensionAow?: {
            grossYearlyAow?: number,
            grossYearlyAowPartner?: number,
            grossSecondPillarYearlyPension?: number,
            grossSecondPillarYearlyPensionPartner?: 0
        },
        pensionAccounts?: [{
            typeOfAdditionalPensionAccount?: string,
            grossPaymentAmountOnInvestmentEndDate?: number,
            investmentEndDate?: string,
            currentValue?: number,
            paymentRecurringAmount?: number,
            paymentRecurringInterval?: string,
            riskProfileId?: string
            }
        ],
        pensionAccountsPartner?: [{
            typeOfAdditionalPensionAccount?: string,
            grossPaymentAmountOnInvestmentEndDate?: number,
            investmentEndDate?: string,
            currentValue?: number,
            paymentRecurringAmount?: number,
            paymentRecurringInterval?: string,
            riskProfileId?: string
            }
        ],
        yearSpaceParameters?: {
            pensionGrowthYearSpace?: number,
            increaseOfFor?: number,
            decreaseOfFor?: number,
            grossYearIncomeYearSpace?: number
        },
        yearSpacePensionAccount?: {
            typeOfAdditionalPensionAccount?: string,
            riskProfileId?: string,
            monthlyPaymentAmount?: number
        },
        box3InvestmentAccount?: {
            paymentSingleAmount?: number,
            paymentRecurringInterval?: string,
            paymentRecurringAmount?: number,
            riskProfileId?: string
        },
        box3SavingsAccount?: {
            paymentSingleAmount?: number,
            paymentRecurringInterval?: string,
            paymentRecurringAmount?: number
        },
        otherIncomeComponents?: {
            giftAmountOnRetirementDate?: number,
            heritageAmountOnRetirementDate?: number,
            surplusHouseAmountOnRetirementDate?: number,
            otherAmountOnRetirementDate?: number
        }
    }
};

export const pensionDialogueDataFromRequest = (body: PensionDialogueDataResponse | undefined) => {
    return {
        personalInfo: {
            self: {
                age: +(body?.answers?.generalSituation?.age ?? 0)
            }
        }
    } as PensionParameters;
};

export const getPensionDialogueDataUrl = (userId: string) => 
    buildEndpoint(['pensiondata', 'client'], [{key: 'id', value: userId}]);

export const getPensionDialogueDataApiCall = (userId: string) =>
    apifetch<PensionDialogueDataResponse>(getPensionDialogueDataUrl(userId), 'GET');

export const useGetPensionDialogueData = () => {
    const { userToken } = useContext(RobotEnvironmentContext)
    const { actions } = useContext(PensionContext);

    const succesfull = (data: PensionDialogueDataResponse | undefined) => {
        if ( data ){
            actions.setParameters(pensionDialogueDataFromRequest(data));
        }
    }

    const query = useQuery<PensionDialogueDataResponse | undefined>(
        ['pensiondata', userToken],
        async () => { 
            if (userToken === undefined)
                return undefined
            return getPensionDialogueDataApiCall(userToken)();
        },{
            enabled: false,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            onSuccess: succesfull
        }
    );

    

    return query;
};